// import { IMilestone, parseMilestone } from "../types/deprecated/IMilestone";

import { IAnyObject } from "../interfaces";
import { Milestone } from "./Milestone";

export class Segment {
	public id: string;
	public segmentType: string;
	public segmentSequenceNo: number;
	public nodeName: string;
	public nodeAddress: string;
	public nodeLocation: string;
	public companyName: string;
	public routeMode: string;
	public routeCarrier: string;
	public routeIdentifier: string;
	public status: string;
	public nodeMode: string;
	public airportName: string;
	public iataCode: string;
	public nodeLat: string;
	public nodeLng: string;
	public flightNumber: string;
	public icaoCode: string;
	public contactName: string;
	public contactPhoneNumber: string;
	public jobIdentifier: string;
	public truckRegistrationNumber: string;
	public aircraftRegistrationNumber: string;
	public trailerIdentifier: string;
	public truckIdentifier: string;
	public driverIdentifier: string;
	public nodeTimeZone: string;
	public locationName: string;
	public routeTelematics: string;
	public milestones: Milestone[];
	public driverTasks: any[];
	public milestonesForRendering: Milestone[];
	public selectedItems: any[];
	public estimatedArrival: any;
	public estimatedArrivalTimeZone: any;
	public endDateTime: any;
	public start: number;
	public startTimeZone: any;
	public end: number;
	public endTimeZone: any;
	public scheduledPickup: any;
	public scheduledPickupTimeZone: any;
	public schStart: any;
	public schStartTimeZone: any;
	public deviceRemoved: any;
	public deviceRemovedTimeZone: any;
	public schEnd: any;
	public schEndTimeZone: any;
	public deviceInstalled: any;
	public deviceInstalledTimeZone: any;
	public readyForPickup: any;
	public readyForPickupTimeZone: any;
	public booked: any;
	public bookedTimeZone: any;
	public code: any;
	public flightDeparted: any;
	public flightDepartedTimeZone: any;
	public acceptedTimeZone: any;
	public accepted: any;
	public flightArrived: any;
	public flightArrivedTimeZone: any;
	public cargoAtFinalDestination: any;
	public cargoAtFinalDestinationDateJson: any;
	public cargoAtFinalDestinationTimeZone: any;
	public notifiedReadyForPickup: any;
	public notifiedReadyForPickupTimeZone: any;
	public delivered: any;
	public deliveredTimeZone: any;
	public leg: string;

	constructor(data: any) {
		this.parse(data);
	}

	private parse(data: any): void {
		this.id = data["SegmentId"];
		this.segmentType = data["SegmentType"];
		this.segmentSequenceNo = data["SegmentSequenceNo"];
		this.nodeName = data["NodeName"];
		this.nodeAddress = data["NodeAddress"];
		this.nodeLocation = data["NodeLocation"];
		this.companyName = data["CompanyName"];
		this.routeMode = data["RouteMode"];
		this.routeCarrier = data["RouteCarrier"];
		this.routeIdentifier = data["RouteIdentifier"];
		this.status = data["Status"];
		this.nodeMode = data["NodeMode"];
		this.airportName = data["AirportName"];
		this.iataCode = data["IataCode"];
		this.nodeLat = data["NodeLat"];
		this.nodeLng = data["NodeLng"];
		this.flightNumber = data["FlightNumber"];
		this.icaoCode = data["IcaoCode"];
		this.contactName = data["ContactName"];
		this.contactPhoneNumber = data["ContactPhoneNumber"];
		this.trailerIdentifier = data["TrailerIdentifier"];
		this.jobIdentifier = data["JobIdentifier"];
		this.truckRegistrationNumber = data["TruckRegistrationNumber"];
		this.aircraftRegistrationNumber = data["AircraftRegistrationNumber"];
		this.truckIdentifier = data["TruckIdentifier"];
		this.driverIdentifier = data["DriverIdentifier"];
		this.nodeTimeZone = data["NodeTimeZone"];
		this.locationName = data["LocationName"];
		this.routeTelematics = data["RouteTelematics"];
		this.selectedItems = data["SelectedItems"] || [];
		this.milestones = data["milestones"] ? data["milestones"].map((_: IAnyObject) => new Milestone(_)) : [];
		this.driverTasks = data["driverTasks"] ? data["driverTasks"] : [];
		if (data["Start"]) {
			this.start = parseInt(data["Start"],10);
		}
		if (data["End"]) {
			this.end = parseInt(data["End"],10);
		}
		if (data["Leg"]) {
			this.leg = data["Leg"];
		}
	}
}
